import { METHOD } from "@cuatroochenta/co-generic-request";
import I18nKeys from "../../../I18n/I18nKeys";
import I18n from "../../I18n/I18n";
import BaseGenericRequest from "../BaseGenericRequest";
import TaskResponse from "../TaskResponse";
import Urls from "../Urls";
import { ReportCustomCriteria } from "./TaskReportList";

type TaskReportExportResponse = TaskResponse<{url: string}>;

export default class TaskReportExport extends BaseGenericRequest<ReportCustomCriteria, TaskReportExportResponse> {
  private readonly data: ReportCustomCriteria;

  public constructor(data: ReportCustomCriteria) {
    super(METHOD.POST, Urls.URL_REPORT_EXPORT_EXCEL);
    this.data = data;

    this.setErrorMessage(404, I18n.tr(I18nKeys.NO_EXISTEN_DENUNCIAS_PARA_EXPORTAR));
    this.setErrorMessage(405, I18n.tr(I18nKeys.INTENTAS_EXPORTAR_MAS_DE_10000_DENUNCIAS));
  }

  protected getRequest(): ReportCustomCriteria {
    return this.data;
  }
}
